export const getObtain = (consultant, index) => {
    const obtain = consultant.medals && consultant.medals.length >= index + 1 ?
        consultant.medals[index].obtained
        :
        false
    return obtain
}

export const getTypeName = (type) => {
    return !type || type === '铜牌' ? '置业顾问' : `${type}顾问`
}

export const handleMedals = (data) => {
    if (data.medals && data.medals.length) {
        if (data.medals[0]) {
            data.medals[0].class_name =  {
                '金牌置业顾问': 'golden',
                '银牌置业顾问': 'silver',
                '铜牌置业顾问': 'bronze'
            }[data.medals[0].name]
        }
        if (data.medals[1]) {
            data.medals[1].class_name = 'excellect'
        }
        if (data.medals[2]) {
            data.medals[2].class_name = 'perfessional'
        }
    }
}